import { Injectable } from 'angular-ts-decorators';

import { IPing } from '@pq-server/server.t';

import { Domain } from '@shared/app/scripts/services/domain';

/**
 * A service to access printQueue
 */
@Injectable('printQueue')
export class PrintQueue {
  constructor(
    private $http: ng.IHttpService,
    private domain: Domain,
  ) {
    'ngInject';
  }

  /**
   * Query /ping
   * @return
   * Reponse of the print queue server.
   */
  ping(): ng.IPromise<IPing> {
    return this.$http
      .get(`//${this.domain.createSibling('pq2')}/ping`)
      .then((response) => <IPing>response.data);
  }
}
